module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/offline-e351607dbdac56db612ed4ddcdd18c4a.svg";